import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from 'helpers/api_helper';

function* fetchPayrollAllowanceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_PAYROLL_ALLOWANCE, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch payroll allowance!');
    }

    yield put({ type: types.FETCH_PAYROLL_ALLOWANCE_SUCCESS, payload: response.data });
  } catch (error) {
    // Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_PAYROLL_ALLOWANCE_FAILURE, payload: error.message });
  }
}

function* savePayrollAllowanceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_PAYROLL_ALLOWANCE, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save payroll allowance!');
    }

    yield put({ type: types.SAVE_PAYROLL_ALLOWANCE_SUCCESS, payload: response.data });
    Swal.fire('Success', response.message || 'Payroll allowance saved!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_PAYROLL_ALLOWANCE_FAILURE, payload: error.message });
  }
}

function* removePayrollAllowanceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_REMOVE_PAYROLL_ALLOWANCE, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to remove payroll allowance!');
    }

    yield put({ type: types.REMOVE_PAYROLL_ALLOWANCE_SUCCESS });
    Swal.fire('Success', response.message || 'Payroll allowance removed!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.REMOVE_PAYROLL_ALLOWANCE_FAILURE, payload: error.message });
  }
}

function* fetchPayrollAllowancesDropdownSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);
    formData.append("type_id", action.payload?.type_id);

    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch allowance dropdown list!');
    }
    yield put({
      type: types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({
      type: types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_FAILURE,
      payload: error.message,
    });
  }
}

function* allowanceGetTemplateSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_FIXED_ALLOWANCE_GETTEMPLATE, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to download template!");
    }

    // ✅ Trigger file download
    if (response?.data) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${response.data}`; // full URL
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "employee_Allowance_template.xlsx"; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    Swal.fire("Success", "Template downloaded successfully!", "success");
    yield put({ type: types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_FAILURE, payload: error });
  }
}

function* allowanceimportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MONTHLY_ALLOWANCE_UPLOAD, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to import Punchlist!");
    }
    Swal.fire('Success', response?.message, response?.status);
    yield put({ type: types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_FAILURE, payload: error });
  }
}

export default function* payrollAllowanceSaga() {
  yield takeLatest(types.FETCH_PAYROLL_ALLOWANCE_REQUEST, fetchPayrollAllowanceSaga);
  yield takeLatest(types.SAVE_PAYROLL_ALLOWANCE_REQUEST, savePayrollAllowanceSaga);
  yield takeLatest(types.REMOVE_PAYROLL_ALLOWANCE_REQUEST, removePayrollAllowanceSaga);
  yield takeLatest(types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_REQUEST, fetchPayrollAllowancesDropdownSaga);
  yield takeLatest(types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_REQUEST, allowanceGetTemplateSaga);
  yield takeLatest(types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT, allowanceimportSaga);
}
